// components/ArticleList.tsx
import React, { } from 'react';
import { Card } from '@mui/material';
import { TFunction } from 'next-i18next';
import Texto from '../../Texto';
import { textosPeque } from '@/constants/Dimens';
import { LogroObj } from '@/objects/Gamificacion';
import ImageCustom from '../../ImageCustom';
import { cargarImagenLogro } from '@/util/Gamificacion';
import { black, lightGray } from '@/constants/Colors';

interface Props {
  t: TFunction;
  logro: LogroObj;
}

const RowLogro: React.FC<Props> = ({ t, logro }) => {
  return (
    <Card
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between',
        width:
          window.innerWidth < 500 ? "94%" : "500px",
        padding: "20px",
        marginTop: "20px",
        color: logro.completado == true ? black : lightGray,
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <section style={{ display: 'flex', flexDirection: 'column', width: "60px" }}>
          <ImageCustom alt={"imagen_logro_" + logro.nombre} src={cargarImagenLogro(logro)} width={50} height={50}
            style={{ ...logro.completado == false ? { filter: 'grayscale(100%)' } : {} }} />
        </section>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "20px", width: "250px" }}>
          <Texto color={logro.completado == true ? black : lightGray}>{logro.nombre}</Texto>
          <Texto color={logro.completado == true ? black : lightGray} fontSize={textosPeque}>{logro.descripcion}</Texto>
        </section>
        <section style={{ display: 'flex', flexDirection: 'row', marginLeft: "20px", width: "100px", gap: "5px", marginRight: "5px" }}>
          <Texto color={logro.completado == true ? black : lightGray}>{logro.puntos}</Texto>
          <Texto color={logro.completado == true ? black : lightGray} >{t("common:articulos.creditos")}</Texto>
        </section>
      </article>
    </Card>
  );
};

export default RowLogro;
